(function () {
  const fashionTypePattern =
    /(服裝|上衣|外套|背心|內衣|運動褲|短褲|褲|鞋|帽|手袋|水桶包|袋\/背包|袋|wallet|hat|cap|t-?shirts?|shirt|sleeveless|blouse|top|pants?|skirt|shoes?|socks?|bags?)/i;
  const colorSwatches = [
    ['grayish lilac', '#aaa2b2'],
    ['honey brown', '#b78355'],
    ['turtledove', '#9b9082'],
    ['cream white', '#f3efe2'],
    ['off white', '#f4f0df'],
    ['melange white', '#ecebe7'],
    ['melange gray', '#aaa9a5'],
    ['light grey', '#d3d4d4'],
    ['light gray', '#d3d4d4'],
    ['dark grey', '#595959'],
    ['dark gray', '#595959'],
    ['deep green', '#29473b'],
    ['dark khaki', '#5e624d'],
    ['warm brown suede', '#7a4f35'],
    ['warm brown', '#7a4f35'],
    ['dark navy', '#20283b'],
    ['grayish blue', '#899aaa'],
    ['burgundy', '#762f3d'],
    ['chocolate', '#594137'],
    ['scarlet', '#7e2638'],
    ['charcoal', '#404040'],
    ['mahogany', '#6b3f35'],
    ['dark stone', '#6f655b'],
    ['light saddle', '#b9875b'],
    ['maple', '#5d3326'],
    ['vanilla', '#f2ead4'],
    ['cashew', '#8a5f43'],
    ['paper', '#eee8da'],
    ['tundra', '#556357'],
    ['caramel', '#b78355'],
    ['saddle', '#a56f43'],
    ['walnut', '#72513f'],
    ['chalk', '#f4f0df'],
    ['stone', '#9d9285'],
    ['mocha', '#806858'],
    ['dulce', '#b78355'],
    ['ruby', '#7e2638'],
    ['bordeaux', '#762f3d'],
    ['silver', '#c2c4c6'],
    ['purple', '#806b89'],
    ['orange', '#c7763c'],
    ['yellow', '#e3c45b'],
    ['ivory', '#f4f0df'],
    ['cream', '#eee5cf'],
    ['beige', '#d8c5a8'],
    ['brown', '#735643'],
    ['black', '#202020'],
    ['white', '#f7f7f5'],
    ['khaki', '#8b8060'],
    ['navy', '#26334d'],
    ['green', '#53705a'],
    ['grey', '#a8aaad'],
    ['gray', '#a8aaad'],
    ['blue', '#6f91aa'],
    ['pink', '#d8aaa9'],
    ['mint', '#aec7bc'],
    ['taupe', '#9a8776'],
    ['gold', '#b89b58'],
    ['sand', '#d3bea0'],
    ['red', '#9f4a4a'],
    ['tan', '#ba8f69'],
    ['oak', '#9a6f4d'],
    ['natural', '#d3bea0'],
    ['brass', '#b89b58'],
    ['黑色', '#202020'],
    ['白色', '#f7f7f5'],
    ['灰色', '#a8aaad'],
    ['淺灰', '#d3d4d4'],
    ['米色', '#d8c5a8'],
    ['啡色', '#735643'],
    ['棕色', '#735643'],
    ['摩卡色', '#806858'],
    ['奶焦糖', '#b78355'],
    ['酒紅色', '#762f3d'],
    ['腰果啡', '#8a5f43'],
    ['灰褐色', '#9b9082'],
    ['苔原綠', '#556357'],
    ['紅色', '#9f4a4a'],
  ];
  const colorWords = colorSwatches.map(([name]) => name);
  const colorPattern = new RegExp(`\\b(?:${colorWords.join('|')})\\b`, 'gi');

  function isFashionProductType(type) {
    return fashionTypePattern.test(String(type || ''));
  }

  function normalizeStyleTitle(title) {
    return String(title || '')
      .normalize('NFKC')
      .toLowerCase()
      .replace(/\[[^\]]*\]/g, ' ')
      .replace(/\([^)]*\)/g, ' ')
      .replace(colorPattern, ' ')
      .replace(/\bin\b/g, ' ')
      .replace(/[^a-z0-9\u3400-\u9fff]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function colorForTitle(title) {
    const normalizedTitle = String(title || '').normalize('NFKC').toLowerCase();
    const match = colorSwatches.find(([name]) => {
      if (/[\u3400-\u9fff]/.test(name)) return normalizedTitle.includes(name);
      return new RegExp(`\\b${name}\\b`, 'i').test(normalizedTitle);
    });
    return match?.[1] || '';
  }

  function styleKey(product) {
    return `${String(product.vendor || '').trim().toLowerCase()}|${normalizeStyleTitle(product.title)}`;
  }

  function groupRelatedProducts(products) {
    const groups = new Map();

    products.forEach((product) => {
      if (!product.handle || !isFashionProductType(product.type)) return;

      const key = styleKey(product);
      if (!key.endsWith('|') && !groups.has(key)) groups.set(key, []);

      const group = groups.get(key);
      if (group && !group.some((item) => item.handle === product.handle)) group.push(product);
    });

    [...groups.entries()].forEach(([key, group]) => {
      if (group.length < 2) groups.delete(key);
    });

    return groups;
  }

  function productFromCard(card) {
    const image = card.querySelector('.card__media img:first-child');
    const link = card.querySelector('.card__heading a[href]');

    return {
      card,
      handle: card.dataset.productCardHandle || '',
      title: card.dataset.productCardTitle || '',
      vendor: card.dataset.productCardVendor || '',
      type: card.dataset.productCardType || '',
      url: link?.getAttribute('href') || '',
      image,
    };
  }

  function createSwatch(product, currentHandle) {
    const color = colorForTitle(product.title);
    if (!color) return null;

    const swatch = document.createElement('a');
    const source = product.image?.getAttribute('src') || '';

    swatch.href = product.url;
    swatch.className = 'card-related-styles__item';
    swatch.setAttribute('aria-label', product.title);
    swatch.dataset.relatedStyleSwatch = '';
    swatch.dataset.relatedStyleSrc = source;
    swatch.dataset.relatedStyleSrcset = product.image?.getAttribute('srcset') || '';
    swatch.dataset.relatedStyleColor = color;
    swatch.style.backgroundColor = color;
    if (product.handle === currentHandle) swatch.setAttribute('aria-current', 'true');

    return swatch;
  }

  function decorateExistingSwatches(root) {
    root.querySelectorAll('.card-related-styles').forEach((container) => {
      const card = container.closest('.product-card-wrapper');
      if (container.hasAttribute('data-variant-color-swatches') && !isFashionProductType(card?.dataset.productCardType)) {
        return;
      }

      const swatches = [...container.querySelectorAll('.card-related-styles__item')];
      const colors = swatches.map((swatch) =>
        colorForTitle(swatch.dataset.variantColorName || swatch.getAttribute('aria-label'))
      );
      if (!swatches.length || colors.some((color) => !color)) return;

      container.classList.add('card-related-styles--colors');
      container.classList.remove('card-related-styles--pending');
      swatches.forEach((swatch, index) => {
        swatch.replaceChildren();
        swatch.dataset.relatedStyleColor = colors[index];
        swatch.style.backgroundColor = colors[index];
      });
    });
  }

  function init(root = document) {
    decorateExistingSwatches(root);

    const cards = [...root.querySelectorAll('.product-card-wrapper[data-product-card-handle]')];
    const products = cards.map(productFromCard).filter((product) => product.image && product.url);
    const groups = groupRelatedProducts(products);

    products.forEach((product) => {
      if (product.card.querySelector('.card-related-styles:not(.card-related-styles--pending)')) return;

      const group = groups.get(styleKey(product));
      if (!group) return;

      const currentFirst = [product, ...group.filter((item) => item.handle !== product.handle)].slice(0, 6);
      const container = document.createElement('div');
      const price = product.card.querySelector('.card-information .price');
      if (!price) return;

      const swatches = currentFirst.map((item) => createSwatch(item, product.handle)).filter(Boolean);
      if (swatches.length < 2) return;

      container.className = 'card-related-styles card-related-styles--colors';
      container.setAttribute('aria-label', '其他顏色及款式');
      swatches.forEach((swatch) => container.appendChild(swatch));
      price.insertAdjacentElement('afterend', container);
    });
  }

  const api = { colorForTitle, groupRelatedProducts, init, isFashionProductType, normalizeStyleTitle };

  if (typeof window !== 'undefined') window.HaruRelatedStyles = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})();
